// AdminListingsPage.styles.js


const AdminListingsPageStyles = {
    container: {
      padding: '2rem',
      maxWidth: '1200px',
      margin: 'auto',
    },
    title: {
      fontWeight: 'bold',
      marginBottom: '2rem',
      textAlign: 'center',
      color: '#333',
    },
    searchField: {
      marginBottom: '1.5rem',
    },
    card: {
      boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    },
    editButton: {
      marginRight: '0.5rem',
    },
    deleteButton: {
      backgroundColor: '#333333',
      '&:hover': {
        backgroundColor: '#000000',
      },
    },
  };
  
  export default AdminListingsPageStyles;
  